const executiveSummary = [
    {
        id: 1,
        qmsResult: "Critical",
        nonComformance: "[Populated from Web Portal]",
        nonComfPoint: "[Populated from Web Portal]"
    },
    {
        id: 2,
        qmsResult: "Major",
        nonComformance: "[Populated from Web Portal]",
        nonComfPoint: "[Populated from Web Portal]"
    },
    {
        id: 1,
        qmsResult: "Minor",
        nonComformance: "[Populated from Web Portal]",
        nonComfPoint: "[Populated from Web Portal]"
    },
]

export default executiveSummary;